import {
  UseMutationResult,
  useMutation,
  useQueryClient
} from '@tanstack/react-query'
import { toast } from 'ui-components'
import { useMap } from '~map-preview/states/map'
import { deleteMapById } from '~map-preview/api/deleteMapById'
import { getWorkspaceByIdQueryKey } from '~workspace/queries/useGetWorkspaceById'

export const useDeleteMap = () => {
  const map = useMap()
  const queryClient = useQueryClient()
  const mutation = useMutation({
    mutationFn: async (id: string) => {
      return deleteMapById(id)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getWorkspaceByIdQueryKey(String(map?.workspaceId)),
        exact: true
      })
    },
    onError: (error) => {
      toast(error.message)
    }
  })

  return mutation as UseMutationResult<unknown>
}
